module.exports = __webpack_public_path__ + "img/meeting.18f63061.png";